import styled from '@emotion/styled';

export const ConnectedFieldsCheckboxGroup = styled.div`
  > * {
    margin: 28px 0;
  }
`;
